<div class="voice_responceBg blackBg liv-bg" [class.paused]="isPaused">
  <div class="d-block">
    <div class="logoBg">
      <a routerLink="/">
        <img src="assets/images/logo.svg" alt="Golf AI" class="top-logo mr-2">
      </a>
    </div>
    @if (isBrowser) {
      <div class="chat-top">
        <div class="icon-wrap">

          <!-- Hiding this animation via css for smooth switching between connecting and thinking states -->
          <ng-lottie 
            class="flag-animation"
            [class.hidden-animation]="!connectingToRoom && agentState !== 'thinking'" 
            [options]="processingOptions">
          </ng-lottie>

          @if ((!connectedToRoom || isPaused) && !connectingToRoom) {
            <div class="static-flag">
              <img src="assets/images/static-flag.svg" alt="">
            </div>
          } @else if (agentState === 'listening') {
            <ng-lottie class="flag-animation" [options]="listeningOptions">
            </ng-lottie>
          } @else if (agentState === 'speaking' && activeAudioTrack) {
            <app-bar-visualizer [mediaStreamTrack]="activeAudioTrack" />
          }
        </div>
        <!-- @if (transcription.text){
                      <div class="transcript" [ngClass]="{'ai-transcript': transcription.isAgent}">
                          <p>{{transcription.text}}</p>
                      </div>
                  } -->
      </div>
    }

    <div class="mic_area">
      <div class="mic-inner">
        <div class="mic-icon">
          @if (!connectedToRoom) {
            @if (connectingToRoom) {
              <button class="btn play" disabled>
                <img src="assets/images/chat-microphone.svg" alt="">
              </button>
            } @else {
              <button (click)="joinCall()" class="btn play">
                <img src="assets/images/chat-microphone.svg" alt="">
              </button>
            }
          } @else {
            @if (isPaused) {
              <button class="btn play" (click)="resumeCall()">
                <img src="assets/images/mute.svg" alt="Resume">
              </button>
            } @else {
              <button class="btn play" (click)="pauseCall()">
                <img src="assets/images/chat-microphone.svg" alt="Pause">
              </button>
            }
          }
        </div>
        <div class="mic-text">
          @if (!connectedToRoom) {
            @if (!connectingToRoom) {
              <p>
                <a class="cursor-pointer" (click)="joinCall()">Tap to Chat</a>
              </p>
            } @else {
              <p>{{'Connecting' | translate}}...</p>
            }
          } @else if (isPaused) {
            <p>
              <a class="cursor-pointer" (click)="resumeCall()">Tap to Resume</a>
            </p>
          } @else {
            <p>{{agentState | titlecase | translate}}...</p>
          }


          <!-- @if (isPaused) {
                      
                    } @else if (agentState === 'thinking') {
                      <p>{{'Thinking' | translate}}...</p>
                    } @else if (agentState === 'listening') {
                      <p>{{'Listening' | translate}}...</p>
                    } @else if (agentState === 'speaking') {
                      <p>{{'Talking' | translate}}...</p>
                    } @else if (connectingToRoom) {
                      
                    } @else if (!connectedToRoom) {
                     
                    } @else {
                      <p>{{'Listeningsss' | translate}}...</p>
                    } -->
          <!-- <p *ngIf="speaking">{{'Speaking' | translate}}...</p>
                    <p *ngIf="aiSpeaking">{{'Talking' | translate}}...</p>
                    <p *ngIf="isProcessing">{{'Processing' | translate}}...</p>
                    <p *ngIf="!speaking && !isProcessing && !aiSpeaking">
                        {{'LetsChat' | translate}}
                    </p> -->
          <!-- <p class="beta-text">(Beta)</p> -->
        </div>
        <div class="leave-btn">
          <button class="btn close" (click)="leavePage()">
            <img src="assets/images/close-microphone.svg" alt="">
          </button>
        </div>
      </div>
    </div>
  </div>